import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import SortIcon from '../Table/SortIcon'

const SORT_BTN_CLASS = 'tw:flex tw:items-center tw:gap-1 tw:bg-transparent tw:border-0 '
  + 'tw:p-0 tw:cursor-pointer tw:text-inherit tw:font-inherit '
  + 'tw:disabled:cursor-not-allowed tw:disabled:opacity-50'

const DataTableColumnHeader = ({ column, title, disabled = false }) => {
  const canSort = column.getCanSort()
  const sortedDirection = column.getIsSorted()

  const handleClick = useCallback(() => {
    column.toggleSorting()
  }, [column])

  if (!canSort)
    return <span>{title}</span>

  return (
    <button
      aria-sort={sortedDirection || 'none'}
      className={SORT_BTN_CLASS}
      disabled={disabled}
      type="button"
      onClick={handleClick}
    >
      <span>{title}</span>
      <SortIcon active={Boolean(sortedDirection)} direction={sortedDirection || 'desc'} />
    </button>
  )
}

DataTableColumnHeader.propTypes = {
  column: PropTypes.shape({
    getCanSort: PropTypes.func.isRequired,
    getIsSorted: PropTypes.func.isRequired,
    toggleSorting: PropTypes.func.isRequired
  }).isRequired,
  disabled: PropTypes.bool,
  title: PropTypes.node.isRequired
}

DataTableColumnHeader.defaultProps = {
  disabled: false
}

export default DataTableColumnHeader
